import React, { useState, useEffect, useRef } from 'react';
import { Page, Navbar, NavRight, Segmented, Button, Block, Tabs, Tab, Icon, Link , Popup, Input ,f7} from "framework7-react";
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from '../globals';

const EventAcceptDetails = ({ f7route }) => {
  const { id, rid } = f7route.params;
  const [data, setEventDetails] = useState([]);  
  const [showOrderHis, setShowOrderHis] = useState([]);
  useEffect(() => {
    axios.get(API_BASE_URL + 'eventacceptdetails/id/'+ localStorage.getItem('id'), {
      headers: {
        'Authorization': 'Basic ' + API_AUTH
      },
      params:{
        event_id : id,
        rest_id:rid, 
        cust_id: localStorage.getItem('id'),
      }
    })
    .then(response => { setEventDetails(response.data.data);
      showOrderStatus(response.data.data[0].order_id);
      } )
    .catch(error => console.log(error));      
}, [id]);
  
  const showOrderStatus = (order_id) => {
    axios.get(API_BASE_URL + 'orderhistory' , {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        },
        params:{
           order_id: order_id,
        }
      })
      .then(response => { 
        setShowOrderHis(response.data.data.reverse());
        console.log(1);
        })
      .catch(error => console.log(error));
  }

  const renderIcon = (orderStatus) => {
      if (orderStatus === 1) {
        return <img class="img-fluid icon step-1" src={require("./../images/svg/cube.svg").default} alt="cube"/>;
      } else if (orderStatus === 2) {
        return <img class="img-fluid icon step-3" src={require("./../images/svg/bike.svg").default} alt="bike"/>;
      } else if (orderStatus === 3) {
        return <img class="img-fluid icon step-2" src={require("./../images/svg/manage-payment.svg").default} alt="3d-cube"/>;
      } else if (orderStatus === 4) {
        return <img class="img-fluid icon step-4" src={require('./../images/svg/done.svg').default} alt="done"/>;
      // } else if (orderStatus === 5) {
      //   return <img class="img-fluid icon step-1 bg-danger" src={require('./../images/svg/empty-cart.svg').default} alt="done"/>;
      } else {
        return null; // Render a default icon or nothing if no matching status
      }
    };
  
  

  return (
    <Page className='bg-white'>
      <div className="container container-table  p-0">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container">
              <div className="header-panel">
                <Link href="#" back reloadAll><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Link>
                <h2>Order Tracking</h2>
                {/* <Link href="#"><Icon ios="material:edit" aurora="material:edit" md="material:edit" className='theme-dark'></Icon></Link> */}
              </div>
            </div>
          </header>
          {data.map(item => ( 
            <div>
          <section>
          <div className="custom-container">        
              <div class="title">
                <h5 className="fw-bold dark-text dark-text"><span className="light-text">Event ID : </span> {item.id}</h5>
                <a href="#" className='text-muted text-1'>{item.bid_start_date}</a>
              </div>
              <div className='apply-coupon mt-3'>
                <h5>Status: <span className='text-success'>{item.order_event_status_txt}</span></h5>
              </div>
              <table className="table 1table-borderless mt-2 text-2">        
                <tbody>
                  <tr>
                    <td width={'40%'}>Event Name: </td>
                    <td><b>{item.event_name}</b></td>
                  </tr>
                  <tr>
                    <td width={'40%'}>Event Date: </td>
                    <td>{item.event_date}</td>
                  </tr>
                  <tr>
                    <td>Event Size: </td>
                    <td>Adults - <strong>{item.event_adult_size}</strong>, Kids - <strong>{item.event_kids_size}</strong></td>
                  </tr>
                  <tr>
                    <td>Food Need By Time: </td>
                    <td>{item.event_by_time}</td>
                  </tr>
                  <tr>
                    <td>Event Address: </td>
                    <td>{item.add_lin_1} {item.add_lin_2} {item.city} {item.state} {item.zip_code}</td>
                  </tr>
                  <tr>
                    <td>Event Notes: </td>
                    <td>{item.event_note}</td>
                  </tr>

                </tbody>
              </table>
              
              {/* <h3 className="fw-bold dark-text mb-2">Restaurant Information</h3> */}
              {/* <div className="vertical-product-box">
                <div className="vertical-box-img p-2" style={{width: '15%'}}>
                  <img alt="" slot="media" src="https://cdn.framework7.io/placeholder/people-160x160-1.jpg" width="40" className="rounded-circle" />
                </div>
                <div className="vertical-box-details">
                  <div className="vertical-box-head">
                    <div className="restaurant">
                      <h5 className="dark-text">Ben &amp; Floren</h5>
                    </div>
                    <h6 className="food-items mb-2" style={{overflow: 'visible'}}><Icon ios="material:location_on" aurora="material:location_on" md="material:location_on" className='text-success text-3'/> 8642 Yule Street, Arvada CO 80007</h6>                    
                  </div>              
                </div>
              </div> */}
            </div>
            <div className="custom-container">
              <h3 className="fw-bold dark-text">Menu Items</h3>
              <table className="table table-striped table-sm text-2 mt-2">
                <tbody>
                {item.event_item.map((items, index) => (
                  <tr>
                    <td width={'10%'} className='text-center'>{index + 1}. </td>
                    <td><h5 className="dark-text fw-bold mb-1">{items.menu_name}</h5>{items.note}</td>                
                  </tr>              
                ))}
                </tbody>
              </table>
            </div> 
            <div className="custom-container">
              <h3 className="fw-bold dark-text">Restaurant Menu Items</h3>
              <table className='table table-striped table-sm text-2 mt-2'>
                <tbody>
                  {item.rest_event.map((rest_event, index) => (
                    <tr>
                        <td width={'10%'} className='text-center'>{index + 1}. </td>
                        <td><h5 className="dark-text fw-bold mb-1">{rest_event.menu_name}</h5><span>Qty : {rest_event.qty},Price : ${rest_event.total_amount}</span></td>                
                      </tr>              
                  ))}
                </tbody>
              </table>      
            </div>
          </section>
          
        <section>
            <div class="custom-container">
                <div class="title">
                    <h5 class="dark-text"><span class="light-text">Order ID : </span>{item.order_id}</h5>
                  </div>
                <div class="order-tracking mt-3">
                    <ul class="tracking-place">
                    {
                    showOrderHis.length > 0 ? 
                    showOrderHis.map((items, index) => (

                    <li className= "active" >
                        <h6>{items.time}</h6>
                        <span></span>
                        {renderIcon(items.order_status_id)}
                        {/* <img class="img-fluid icon step-1" src={require(`./../images/svg/${icon}`).default} alt="cube"/> */}
                        <h6 class="color-1">{items.order_status}</h6>
                        <h6 class="color-1">{items.message}</h6>
                    </li>
                    )):<div>Order Have No History</div>
                  }

                    
                    
                    </ul>
                </div>
            </div>
        </section>
      </div>
          ))}
        </div>
      </div>
    </Page>
  );
};

export default EventAcceptDetails    ;